export default __webpack_public_path__ + "static/media/settings-white.2c203595.svg";